export const STATUS_DICT = [
    {
        key: 1,
        value: 1,
        label: '正常',
        color: 'success',
    },
    {
        key: 2,
        value: 2,
        label: '冻结',
        color: 'warning',
    },
    {
        key: 3,
        value: 3,
        label: '删除',
        color: 'error',
    },
]

export const GENDER_DICT = [
    {
        label: '男',
        value: 1,
    },
    {
        label: '女',
        value: 0
    }
]

export const DEFAULT_QUERY = {
    pageSize: 10,
    pageNum: 1,

}
